"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { Problem } from "./problem";
import { Solution } from "./solution";
import { CapabilityOverview } from "./capability-overview";
import { HowItWorks } from "./how-it-works";
import { CoreFeatures } from "./core-features";
import { AdvancedFeatures } from "./advanced-features";
import { UseCases } from "./use-cases";
import { Benefits } from "./benefits";
import { Usps } from "./usps";
import { WhoItsFor } from "./who-its-for";
import { WhyChooseUs } from "./why-choose-us";
import { Related } from "./related";
import { FAQ } from "./faq";
import { PAA } from "./paa";
import { CTA } from "./cta";

export function SocialMediaManagementPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <ExecutiveSummary />
      </div>
      <Problem />
      <div className="bg-aurora-crimson">
        <Solution />
      </div>
      <CapabilityOverview />
      <div className="bg-aurora-emerald">
        <HowItWorks />
      </div>
      <CoreFeatures />
      <div className="bg-aurora-violet">
        <AdvancedFeatures />
      </div>
      <UseCases />
      <div className="bg-aurora-emerald">
        <Benefits />
      </div>
      <Usps />
      <div className="bg-aurora-denim">
        <WhoItsFor />
      </div>
      <WhyChooseUs />
      <Related />
      <div className="bg-aurora-cyan">
        <FAQ />
      </div>
      <PAA />
      <CTA />
    </>
  );
}
